import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/global.css';
import { login } from '../auth/authService';

const LoginForm = () => {
  const [isHovered, setIsHovered] = useState(false);
  // eslint-disable-next-line
  const [isDisabled, setIsDisabled] = useState(true); // Set initial disabled state

  const handleHover = () => {
    setIsHovered(true);
  };

  const handleLeave = () => {
    setIsHovered(false);
  };
  const navigate = useNavigate(); // useNavigate replaces useHistory in React Router v6
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showAlert, setShowAlert] = useState(false); // State to control the alert visibility

  const handleLogin = (e) => {
    // e.preventDefault(); // Prevent default form submission
    // if (email === 'testing123@gmail.com' && password === 'test') {
    //   // Redirect to '/home' upon successful login
    //   navigate('/home');
    // } else {
    //   // Show alert for invalid credentials
    //   setShowAlert(true);
    // }
    e.preventDefault(); // Prevent default form submission
    if (login(email, password)) {
      // Redirect to '/home' upon successful login
      navigate('/home');
    } else {
      // Show alert for invalid credentials
      setShowAlert(true);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="bg">
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="card p-4 shadow" style={{ minWidth: '350px' }}>
        <h4 className='urdu-text logintext'>اللهم صل على محمد وعلى آل محمد كما صليت على إبراهيم وعلى آل إبراهيم إنك حميد مجيد</h4>
        <h5 className='loginheading urdu-text'>آل پاکستان مریدین فہرست حضرت محبوب ذات منڈیر شریف سیداں سیالکوٹ</h5>         
          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Password</label>
              <div className="input-group">
                <input
                  type={showPassword ? "text" : "password"}
                  className="form-control"
                  id="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={togglePasswordVisibility}
                  style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </div>
            {/* Conditional rendering for alert */}
            {showAlert && (
              <div className="alert alert-danger" role="alert">
                Invalid email or password
              </div>
            )}
            <div className="d-grid gap-2">
              <button type="submit" className="login-btn btn-primary mt-3">Login Now</button>
              <p className="m-auto font-weight-bold">OR</p>
              <button
      type="button"
      className={`signup-btn btn-secondary ${isDisabled ? 'disabled' : ''}`}
      disabled={isDisabled}
      onMouseEnter={handleHover}
      onMouseLeave={handleLeave}
    >
      {isHovered && isDisabled && <span className="hover-icon">🚫</span>}
      Signup
    </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
